import { Component, OnInit } from '@angular/core';
import { DashboardComponent } from '../app/shared/index';
import { AuthService } from './authentication/service/auth.service';
import { GlobalEventsManager } from './app-global-events-manager';
import { UserParametersService } from './authentication/service/cognito.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'app';
  isAutharized: boolean;
  isWorkerBase: boolean;
  isSellerBase: boolean;
  constructor(private authService: AuthService, private globalEventsManager: GlobalEventsManager,
    public userParameterService: UserParametersService, private router: Router,
    private translate: TranslateService) {
    localStorage.removeItem('firebase:previous_websocket_failure');
    this.globalEventsManager.showNavBarEmitter.subscribe((mode) => { this.isAutharized = mode; });
    this.globalEventsManager.showNavBarSellerEmitter.subscribe((mode) => { this.isSellerBase = mode; });
    this.globalEventsManager.showNavBarWorkerEmitter.subscribe((mode) => { this.isWorkerBase = mode; });
    translate.setDefaultLang('se');
  }

  ngOnInit() {

    if (navigator.userAgent.match(/Android/i)
      || navigator.userAgent.match(/webOS/i)
      || navigator.userAgent.match(/iPhone/i)
      || navigator.userAgent.match(/BlackBerry/i)
      || navigator.userAgent.match(/Windows Phone/i)) {
      this.router.navigate(['/mobileview']);
    } else {
      // check the weather worker registration or Extra
      if (!window.location.href.includes('worker/registration')) {
        this.authService.isAuthenticated()
          .then(authenticated => {
            if (authenticated) {
              this.isAutharized = true;
              this.authService.getLoggedInUser().then(result => {
                if (result != null) {
                  this.globalEventsManager.showNavBarRoleName(result.role.toLowerCase());
                  if (result.role.toLowerCase() === 'worker' || result.role.toLowerCase() === 'sub_supplier') {
                    this.isWorkerBase = true;
                    this.isSellerBase = false;
                    this.globalEventsManager.showNavBarSeller(false);
                    this.globalEventsManager.showNavBarWorker(true);
                    this.globalEventsManager.showNavBar(true);
                    // this.router.navigate(['/worker/safetybox']);
                  } else {
                    this.isSellerBase = true;
                    this.isWorkerBase = false;
                    // this.router.navigate(['/seller/profile']);
                    this.globalEventsManager.showNavBarSeller(true);
                    this.globalEventsManager.showNavBarWorker(false);
                    this.globalEventsManager.showNavBar(true);
                  }
                }
              });
            } else {
              this.isAutharized = false;
              this.authService.logout();
              this.isWorkerBase = false;
              this.isSellerBase = false;
              this.router.navigate(['/login']);
            }
          });
      }

    }


  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts